<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<p>Together, side by side, Brandon, Madison, and Isaiah slowly walked out of the cave. They climbed onto their horses and galloped away.</p>
<p>When they got back to the farm, they went into the cabin, grabbed a burlap sack, a bottle, and the Eye of God, and left again. The three walked to a family burial plot. When they got there, they took out spades and started digging with the fastest need.</p>
<p>“Where is she? She said she would meet us here,” Isaiah exclaimed.</p>
<p>“Do not worry, she will come,” Madison said.</p>
<p>All of the sudden, a cloaked figure approached. Seconds later, the person took their hood off; it was Ruth.</p>
<p>“I am sorry I took so long. I was being watched,” Ruth said.</p>
<p>“Do you have what we need?” Brandon asked.</p>
<p>“Yes, I have it right here,” Ruth said, pulling a piece of parchment out of her cloak. “The spell is simple, but you three will have to cast it.”</p>
<p>Isaiah unrolled the parchment and looked at it.</p>
<p>“It says it is a Spell of Protection invoking the protection of the Archangel Luca and Gabriel.”</p>
<p>The three children continued to dig. Though there was a slight breeze, it was very warm. When the hole was deep enough, they stopped digging.</p>
<p>Isaiah took out a bottle filled with holy water and sprinkled it on the burlap sack and the Eye of God. He wrapped up the Eye of God, putting it in the burlap sack, and placed it in the freshly dug hole. Then the kids took the spades and covered the hole back up again.</p>
<p>When they were done, Isaiah sprinkled the last of the holy water on the dirt. Then the children took the protection spell and began chanting the incantations. When they were done, Ruth rolled up the piece of parchment and put it back into her cloak.</p>
<p>“What do you think the time to come will be like?” Isaiah asked.</p>
<p>“I cannot guess. But let us hope it is not terrifying,” Madison said.</p>
<p>And the four of them walked back to the farm and to their unforeseen future.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?44643eae